import {post} from '../index'
export default {
  // 支付码
  reductionStaffQrList (querys) {
    return post('/reduction/admin/AdminRecord/staffQrList', querys)
  },
  // 生成支付码
  reductionPayQr (querys) {
    return post('/reduction/admin/AdminRecord/reductionPayQr', querys)
  },
  // 发放记录
  reductionStaffRecordList (querys) {
    return post('/reduction/admin/AdminRecord/staffRecordList', querys)
  },
  // 领取记录
  reductionUserRecordList (querys) {
    return post('/reduction/admin/AdminRecord/userRecordList', querys)
  },
  // 支付记录
  reductionPayRecordList (querys) {
    return post('/reduction/admin/AdminRecord/payRecordList', querys)
  },
  // 添加满减券
  reductionActiveAdd (querys) {
    return post('/reduction/admin/AdminActive/activeAdd', querys)
  },
  // 回显
  reductionActiveInfo (querys) {
    return post('/reduction/admin/AdminActive/activeInfo', querys)
  },
  // 编辑
  reductionActiveUpdate (querys) {
    return post('/reduction/admin/AdminActive/activeUpdate', querys)
  },
  // 满减券列表
  reductionActiveList (querys) {
    return post('/reduction/admin/AdminActive/activeList', querys)
  },
  // 获取活动可用员工信息
  reductionGetStaffInfo (querys) {
    return post('/reduction/admin/AdminActive/getStaffInfo', querys)
  },
  // 开始/停止发放
  reductionStopActive (querys) {
    return post('/reduction/admin/AdminActive/stopActive', querys)
  },
  // 生成满减券推广码
  reductionCouponShareQr (querys) {
    return post('/reduction/admin/AdminActive/couponShareQr', querys)
  },
  // 提现记录
  reductionWalletList (querys) {
    return post('/commission/admin/AdminWallet/walletList', querys)
  },
  // 提现-驳回
  reductionNoPass (querys) {
    return post('/commission/admin/AdminWallet/noPass', querys)
  },
  // 提现-通过
  reductionPass (querys) {
    return post('/commission/admin/AdminWallet/pass', querys)
  },
  // 佣金记录
  reductionWaterList (querys) {
    return post('/commission/admin/AdminWater/waterList', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/reduction.js